import { useEffect, useRef } from "react"

// Open layers in a browser without CloseWatcher, oldest first; Escape closes only the newest.
const escapeLayers = []

function closeNewestOnEscape(event) {
  if (event.key !== "Escape" || !escapeLayers.length) return
  event.preventDefault()
  escapeLayers[escapeLayers.length - 1].current()
}

// Closes an open layer on the Android back gesture or Escape; the newest layer closes first.
export default function useCloseRequest(isOpen, onClose) {
  const onCloseRef = useRef(onClose)

  useEffect(() => {
    onCloseRef.current = onClose
  })

  useEffect(() => {
    if (!isOpen) return undefined

    if (typeof window.CloseWatcher === "function") {
      const watcher = new window.CloseWatcher()
      watcher.onclose = () => onCloseRef.current()
      return () => watcher.destroy()
    }

    const layer = onCloseRef
    escapeLayers.push(layer)
    if (escapeLayers.length === 1) document.addEventListener("keydown", closeNewestOnEscape)
    return () => {
      escapeLayers.splice(escapeLayers.indexOf(layer), 1)
      if (!escapeLayers.length) document.removeEventListener("keydown", closeNewestOnEscape)
    }
  }, [isOpen])
}
